module.exports = __webpack_public_path__ + "static/img/13bg_7.4d4a0f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/13bg_7.png
// module id = 643
// module chunks = 1